import {
  ApiBlueprint,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { convertLegacyEntityContentExtension } from '@backstage/plugin-catalog-react/alpha';
import {
  EntityCloudbuildContent,
  cloudbuildApiRef,
  isCloudbuildAvailable,
} from '@backstage-community/plugin-cloudbuild';
import { ProxiedCloudbuildClient } from './ProxiedCloudbuildClient';

// O plugin @backstage-community/plugin-cloudbuild só existe no sistema de
// frontend antigo (sem export /alpha). Em vez de converter o plugin
// inteiro, registramos manualmente só as duas peças necessárias: a API
// (que já é um ApiRef do sistema novo) e o conteúdo da entidade, convertido
// via o helper oficial `convertLegacyEntityContentExtension` (que já
// envolve o componente antigo com compatWrapper internamente). Ver F-0030
// design.md D1.
const cloudbuildApiOverride = ApiBlueprint.make({
  params: define =>
    define({
      api: cloudbuildApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ProxiedCloudbuildClient({ discoveryApi, fetchApi }),
    }),
});

const cloudbuildContent = convertLegacyEntityContentExtension(
  EntityCloudbuildContent,
  {
    name: 'cloudbuild',
    path: '/cloudbuild',
    title: 'Cloud Build',
    filter: isCloudbuildAvailable,
  },
);

export const cloudbuildModule = createFrontendModule({
  pluginId: 'app',
  extensions: [cloudbuildApiOverride, cloudbuildContent],
});
